import type { TauriMessageNotification, TauriShownMessageNotification } from '../../types/tauri';

import { IS_MAC_OS } from '../browser/windowEnvironment';

export default function initTauriApi() {
  const corePromise = import('@tauri-apps/api/core');
  async function markTitleBarOverlay(isOverlay: boolean) {
    if (!IS_MAC_OS) return;
    const core = await corePromise;
    return core.invoke<void>('mark_title_bar_overlay', { isOverlay });
  }

  async function setNotificationsCount(amount: number, isMuted = false) {
    const core = await corePromise;
    return core.invoke<void>('set_notifications_count', { amount, isMuted });
  }

  async function showMessageNotification(notification: TauriMessageNotification) {
    const core = await corePromise;
    return core.invoke<void>('show_message_notification', notification);
  }

  async function closeMessageNotification(notification: TauriShownMessageNotification) {
    const core = await corePromise;
    return core.invoke<void>('close_message_notification', notification);
  }

  async function openNewWindow(url: string) {
    const core = await corePromise;
    return core.invoke<boolean>('open_new_window_cmd', { url });
  }

  async function setWindowTitle(title: string) {
    const core = await corePromise;
    return core.invoke<void>('set_window_title', { title });
  }

  async function revealInDownloads(fileName: string) {
    const core = await corePromise;
    return core.invoke<boolean>('reveal_in_downloads', { fileName });
  }

  // @ts-expect-error
  window.tauri ??= {};
  Object.assign(window.tauri, {
    markTitleBarOverlay,
    setNotificationsCount,
    showMessageNotification,
    closeMessageNotification,
    openNewWindow,
    relaunch: () => import('@tauri-apps/plugin-process').then(({ relaunch }) => relaunch()),
    checkUpdate: () => import('@tauri-apps/plugin-updater').then(({ check }) => check()),
    getCurrentWindow: () => import('@tauri-apps/api/window').then(({ getCurrentWindow }) => getCurrentWindow()),
    setWindowTitle,
    revealInDownloads,
  });
}
